// Callee identity sent to make_call for the walker handling last-mile delivery
export const WALKER_CALLED_TO = 'Walker';
export const WALKER_CALLEE_ROLE = 'WALKER';
